export const loadRazorpay = async (razorpayOrder, order, navigate, { setLoading, showToast } ) => {
    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };


    const isLoaded = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!isLoaded) {
        showToast?.("Failed to load Razorpay. Check your internet connection.");
        return;
    }

    const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,  
        amount: razorpayOrder.amount,
        currency: "INR",
        name: "Paltu",
        description: "Medicine Purchase",
        order_id: razorpayOrder.id,
        handler: async function (response) {
            await verifyPayment(response, order, navigate, setLoading, showToast);
        },
        prefill: {
            name: "User Name",
            email: "user@example.com",
            contact: "9999999999",
        },
        theme: { color: "#3399cc" },
        modal: {
            escape: false,
            ondismiss: async function () {
                await handleFailedPayment(order, navigate, setLoading, showToast);
            }
        }
    };


    const rzp = new window.Razorpay(options);
    rzp.open();
};


const verifyPayment = async (paymentResponse, order, navigate, setLoading, showToast) => {
    try {
        setLoading?.(true);
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/payment-success`, {
            method: "POST",
            headers: { "Content-Type": "application/json"},
            credentials: "include",
            body: JSON.stringify({
                order_id: order.razorpayOrderId,
                payment_id: paymentResponse.razorpay_payment_id,
                signature: paymentResponse.razorpay_signature,
                amount: order.totalPrice * 100,
                receiptNumber: order.receiptNumber,
            }),
        });

       const data = await response.json();
       console.log(data)
        if (!response.ok) {
            throw new Error(data.error || "Payment verification failed!");
        }
        navigate("/")
        showToast?.("Payment Successful! You can view your orders.",{type: "success"});
    } catch (error) {
        showToast?.("Payment verification failed!",{type: "error"});
    }
    finally {
        setLoading?.(false);
    }
};

const handleFailedPayment = async (order, navigate, setLoading, showToast) => {
    try {
        setLoading?.(true);
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/payment-failed`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
                order_id: order.razorpayOrderId,
                error_description: "User closed payment page or payment failed",
            }),
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.error || "Failed to record payment failure");
        }
        navigate("/")
        showToast?.("Payment failed! You can retry from our orders page.",{type: "error"});
    } catch (error) {
        showToast?.("Failed to record payment failure",{type: "error"});
    }finally {
        setLoading?.(false);
    }
};

